module.exports = __webpack_public_path__ + "img/pill.f4dc4e7a.svg";